import { combineReducers } from "@reduxjs/toolkit";
import adminSlice from "../slices/adminSlice";
import { baseApi } from "../../services/baseApi";
import  physicianSlice from "../slices/physicianSlice";
import patientSlice from "../slices/patientSlice";
// import hospitalSlice from "../slices/hospitalSlice";

const reducers = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  admin: adminSlice,
  physician: physicianSlice,
  patient: patientSlice
});

export default reducers;
